document.addEventListener('DOMContentLoaded', () => {
  function initializeScrollBehavior() {
    if (window.innerWidth < 960) {
      return;
    }

    const originalScrollTo = window.scrollTo;

    window.scrollTo = function (...args) {
      const options = (typeof args[0] === 'object') ? args[0] : { top: args[1] };
      const isAnchorScroll = window.location.hash && options.behavior !== 'smooth';

      if (isAnchorScroll) {
        const coursenav = document.getElementById('coursenav');
        if (! (coursenav instanceof HTMLElement)) {
          return;
        }

        const adminBarOffset = document.body.classList.contains('admin-bar') ? 32 : 0;
        const stickyOffset = coursenav ? coursenav.offsetHeight + adminBarOffset : 0;
        const adjustedTop = options.top - stickyOffset;
        originalScrollTo.call(window, { ...options, top: adjustedTop });

        setTimeout(() => {
          const activeItems = coursenav.querySelectorAll('.x-currently-active');
          if (activeItems instanceof NodeList && activeItems.length > 0) {
            activeItems.forEach(item => item.classList.remove('x-currently-active'));
          }

          const activeLink = document.querySelector(`a[href="#${window.location.hash.substring(1)}"]`);
          if (activeLink instanceof HTMLElement) {
            activeLink.classList.add('x-currently-active');
          }
        }, 400);
      } else {
        originalScrollTo.apply(window, args);
      }
    };

    function adjustInitialScrollPosition() {
      const hash = window.location.hash.substring(1);
      if (!hash) {
        return;
      }

      const targetElement = document.querySelector(`#${hash}`);
      if (targetElement instanceof HTMLElement) {
        const coursenav = document.getElementById('coursenav');
        if (!(coursenav instanceof HTMLElement)) {
          return;
        }

        const adminBarOffset = document.body.classList.contains('admin-bar') ? 32 : 0;
        const stickyOffset = coursenav ? coursenav.offsetHeight + adminBarOffset : 0;
        originalScrollTo.call(window, {
          top: targetElement.offsetTop - stickyOffset,
          behavior: 'auto'
        });

        const activeItems = document.querySelectorAll('.x-currently-active');
        if (activeItems instanceof NodeList && activeItems.length > 0) {
          activeItems.forEach(item => item.classList.remove('x-currently-active'));
        }

        const activeLink = document.querySelector(`a[href="#${hash}"]`);
        if (activeLink instanceof HTMLElement) {
          activeLink.classList.add('x-currently-active');
        }
      }
    }

    window.addEventListener('load', adjustInitialScrollPosition);
    window.addEventListener('hashchange', adjustInitialScrollPosition);
  }

  const coursenav = document.getElementById('coursenav');
  if (! (coursenav instanceof HTMLElement)) {
    return;
  }

  initializeScrollBehavior();
  window.addEventListener('resize', initializeScrollBehavior);
});
